import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "./Header";
import CustomerForm from "./CustomerForm";
import SearchEditData from "./SearchEditData";
import {
  Box,
  Card,
  CircularProgress,
  Divider,
  Typography,
} from "@mui/material";
import CustomerList from "./CustomerList";
import {
  Add,
  BadgeOutlined,
  Edit,
  InsertChartOutlined,
  ManageSearch,
  Person4,
  Person4Outlined,
  PersonOutline,
  PersonOutlined,
} from "@mui/icons-material";
import Footer from "./Footer";
import AudioRecording from "./AudioRecording";
import { setupInitialDate } from "../utils/utils";

const Home = ({ onLogout }) => {
  const [currentTab, setCurrentTab] = useState(null);
  const [sheetData, setSheetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fieldLoading, setFieldLoading] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [parent, setParent] = useState(null);
  const [showUnsavedPopup, setShowUnsavedPopup] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [appFields, setAppFields] = useState({});
  const [followUpLoading,setFollowUpLoading] = useState(false)
  const [followUps, setFollowUps] = useState([])

  const getSheetData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/getCustomers`,
        {
          method: "GET", // Specify the HTTP method (GET in this case)
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional: Specify the content type
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Customer data:", data);
      let dataWithUpdatedDate = data?.map((dataItem) => {
        return setupInitialDate(dataItem);
      });
      setSheetData(dataWithUpdatedDate);
      // Handle the data as needed (e.g., update the UI)
    } catch (error) {
      console.error("Error fetching customers:", error);
      // Handle the error (e.g., show an error message to the user)
    } finally {
      setLoading(false);
    }
  };

  const getTodaysFollowUps = async () => {
    setFollowUpLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-follow-ups`,
        {
          method: "GET", // Specify the HTTP method (GET in this case)
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional: Specify the content type
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("FollowUps data:", data?.data);
      setFollowUps(data?.data)
      // Handle the data as needed (e.g., update the UI)
    } catch (error) {
      console.error("Error fetching followups:", error);
      // Handle the error (e.g., show an error message to the user)
    } finally {
      setFollowUpLoading(false);
    }
  };

  const getAppFields = async () => {
    setFieldLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/getFields`,
        {
          method: "GET", // Specify the HTTP method (GET in this case)
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional: Specify the content type
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("fields data:", data);
      setAppFields(data);
      // Handle the data as needed (e.g., update the UI)
    } catch (error) {
      console.error("Error fetching customers:", error);
      // Handle the error (e.g., show an error message to the user)
    } finally {
      setFieldLoading(false);
    }
  };

  useEffect(() => {
    getSheetData();
    getAppFields();
    getTodaysFollowUps();
  }, []);

  const tabs = {
    addNew: (
      <CustomerForm
        setCurrentTab={setCurrentTab}
        sheetData={sheetData}
        setSheetData={setSheetData}
        editForm={false}
        showEditForm={showEditForm}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        getSheetData={getSheetData}
        showUnsavedPopup={showUnsavedPopup}
        setShowUnsavedPopup={setShowUnsavedPopup}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
        appFields={appFields}
      />
    ),
    editCurrent: (
      <SearchEditData
        setCurrentTab={setCurrentTab}
        sheetData={sheetData}
        setSheetData={setSheetData}
        showEditForm={showEditForm}
        setShowEditForm={setShowEditForm}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        getSheetData={getSheetData}
        parent={parent}
        showUnsavedPopup={showUnsavedPopup}
        setShowUnsavedPopup={setShowUnsavedPopup}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
        appFields={appFields}
      />
    ),
    searchEntry: (
      <CustomerList
        setCurrentTab={setCurrentTab}
        sheetData={sheetData}
        setSheetData={setSheetData}
        loading={loading}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        showEditForm={showEditForm}
        setShowEditForm={setShowEditForm}
        getSheetData={getSheetData}
        setParent={setParent}
        showUnsavedPopup={showUnsavedPopup}
        setShowUnsavedPopup={setShowUnsavedPopup}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
      />
    ),
    audioRecorder: <AudioRecording setCurrentTab={setCurrentTab} />,
  };
  // const followUps = [
  //   {
  //     "Prospect Card No.": "32505",
  //     "Customer Name": "Prince Jain, utkarsh",
  //     "Lead Status": "Hot",
  //   },
  //   {
  //     "Prospect Card No.": "32518",
  //     "Customer Name": "Sahil khan",
  //     "Lead Status": "Warm",
  //   },
  // ];

  return (
    <Box className="home_page_container">
      <Header
        handleLogout={onLogout}
        setCurrentTab={setCurrentTab}
        showUnsavedPopup={showUnsavedPopup}
        setShowUnsavedPopup={setShowUnsavedPopup}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
      />
      <Box className="HomeTabBox">
        {(loading || fieldLoading || followUpLoading) && !currentTab ? (
          <Box className="home_tab_loader">
            <CircularProgress />{" "}
            <Typography variant="subtitle1">Getting data...</Typography>{" "}
          </Box>
        ) : currentTab ? (
          tabs[currentTab]
        ) : (
          <div className="home_page_main">
            <div className="home_page_cards_wrapper">
              <Card
                className="home_page_card"
                onClick={() => {
                  setParent(null);
                  setCurrentTab("addNew");
                }}
              >
                <Box className="home_card_content">
                  <Box className="home_icon_wrapper">
                    <Add />
                  </Box>
                  <Typography>Add</Typography>
                </Box>
              </Card>
              <Card
                className="home_page_card"
                onClick={() => {
                  setParent(null);
                  setCurrentTab("editCurrent");
                }}
              >
                <Box className="home_card_content">
                  <Box className="home_icon_wrapper">
                    <Edit />
                  </Box>
                  <Typography>Edit</Typography>
                </Box>
              </Card>
              <Card
                className="home_page_card"
                onClick={() => {
                  setParent(null);
                  setCurrentTab("searchEntry");
                }}
              >
                <Box className="home_card_content">
                  <Box className="home_icon_wrapper">
                    <ManageSearch />
                  </Box>
                  <Typography>Search</Typography>
                </Box>
              </Card>
              <Card className="home_page_card home_page_card_followups">
                <Typography variant="h6" sx={{ mb: 2 }}>
                  <b>Today's Follow-Ups</b>
                </Typography>
               <Box className="follow_up_cards_wrapper">
               {followUps?.length > 0 ? followUps?.map((followup, index) => {
                  return (
                    <Box
                      className={
                        index % 2 === 0 ? "followupeven" : "followupodd"
                      }
                    >
                      <Typography variant="subtitle2" className="followup_item">
                        <BadgeOutlined /> <b>Prospect Card No </b>{" "}
                        -
                        {followup?.["Prospect Card No."]}
                      </Typography>
                      <Typography variant="subtitle2" className="followup_item">
                        <PersonOutlined /> <b>Customer Name </b>{" "}
                        -
                        {followup?.["Customer Name"]}
                      </Typography>
                      {localStorage.getItem("role") === "Head" &&  <Typography variant="subtitle2" className="followup_item">
                        <Person4Outlined /> <b>Sales Consultant </b>{" "}
                        -
                        {followup?.["Sales Consultant"]}
                      </Typography>}
                      <Typography variant="subtitle2" className="followup_item">
                        <InsertChartOutlined /> <b>Lead Status </b>{" "}
                        -
                        {followup?.["Lead Status"]}
                      </Typography>
                      {/* {followUps?.length -1 !== index && <Divider sx={{mt:2, mb:2}}/>} */}
                    </Box>
                  );
                }) : <Typography variant="subtitle2">No follow-ups for today.</Typography>}
               </Box>
              </Card>
            </div>
          </div>
        )}
      </Box>
      <Footer />
    </Box>
  );
};

export default Home;
